import React, { useState } from 'react';
import { styled } from '@mui/material';
import {
    RFieldGroup,
    REmailInput,
    RPasswordInput,
    RPillButton,
    RErrorText,
    RTextButton,
    RText,
} from 'recruit/components';
import { Row } from 'library/ui';
import { recruitLogin } from 'recruit/api/candidate_auth';
import { setRecruitToken, useRecruitCandidateUser } from 'recruit/context/RecruitCandidateUserContext';

interface CandidateLoginFormProps {
    onSuccess: () => void;
    onSwitchToCreateAccount: () => void;
    onForgotPassword: () => void;
}

export function CandidateLoginForm({ onSuccess, onSwitchToCreateAccount, onForgotPassword }: CandidateLoginFormProps) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { refreshCandidateUser } = useRecruitCandidateUser();

    async function handleSubmit() {
        setError('');

        if (!email || !password) {
            setError('Please enter your email and password.');
            return;
        }

        setLoading(true);
        try {
            const res = await recruitLogin(email, password);
            setRecruitToken(res.key);
            await refreshCandidateUser();
            onSuccess();
        } catch {
            setError('Invalid email or password.');
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <form onSubmit={handleSubmit}>
                <FieldStack>
                    <RFieldGroup label="Email">
                        <REmailInput value={email} onChange={(val) => setEmail(val)} fullWidth />
                    </RFieldGroup>
                    <RFieldGroup label="Password">
                        <RPasswordInput
                            value={password}
                            onChange={setPassword}
                            placeholder="Enter your password"
                            fullWidth
                        />
                    </RFieldGroup>
                    {error && <RErrorText>{error}</RErrorText>}
                    <Row justify="end">
                        <RTextButton onClick={onForgotPassword}>Forgot password?</RTextButton>
                    </Row>
                    <RPillButton onClick={handleSubmit} disabled={loading}>
                        {loading ? 'Logging in...' : 'Log In'}
                    </RPillButton>
                </FieldStack>
            </form>
            <Row gap="sm" justify="center">
                <RText>Don&apos;t have an account? </RText>
                <RTextButton onClick={onSwitchToCreateAccount}>Create an account</RTextButton>
            </Row>
        </>
    );
}

const FieldStack = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
});

